import { withStyles } from '@material-ui/core/styles'

import gameday_white from '../../../../assets/images/gameday_white.png'
import not_found_bg from '../../../../assets/images/not_found_bg.jpg'

const styles = theme => ({
  page: {
    position: 'fixed',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-evenly',
    textAlign: 'center',
    width: '100vw',
    height: '100vh',
    background: `url(${not_found_bg}) no-repeat center center fixed`,
    backgroundSize: 'cover',
    '-webkit-font-smoothing': 'antialiased',
    '-moz-osx-font-smoothing': 'grayscale',
  },
  content: {
    color: theme.colors.white,
    lineHeight: 1.3,
    padding: '0 1rem',
  },
  heroText: {
    fontSize: '10rem',
    fontWeight: theme.typography.fontWeightBold,
    lineHeight: 1,
    marginBottom: '1rem',
    [theme.breakpoints.down('xs')]: {
      fontSize: '5rem',
    },
  },
  title: {
    fontSize: theme.typography.fontSizeBase,
    fontWeight: theme.typography.fontWeightBolder,
    color: theme.colors.white,
    marginBottom: '0.625rem',
    [theme.breakpoints.down('xs')]: {
      fontSize: theme.typography.fontSizeSm,
    },
  },
  message: {
    margin: 0,
    fontSize: theme.typography.fontSizeBase,
    color: theme.colors.white,
    [theme.breakpoints.down('xs')]: {
      fontSize: theme.typography.fontSizeSm,
    },
  },
  extra: {
    paddingTop: '3rem',
    '& .MuiButton-containedPrimary': {
      padding: '0 2rem',
    },
  },
  footer: {
    paddingTop: '4rem',
  },
  logo: {
    display: 'inline-block',
    width: 180,
  },
})

const NotFoundPage = ({ children, classes, message, title }) => (
  <main className={classes.page}>
    <header />
    <div className={classes.content}>
      <div className={classes.heroText}>404</div>
      <h1 className={classes.title}>{title}</h1>
      <p className={classes.message}>{message}</p>
      <div className={classes.extra}>{children}</div>
    </div>
    <footer className={classes.footer}>
      <img className={classes.logo} src={gameday_white} alt="GameDay" />
    </footer>
  </main>
)

NotFoundPage.defaultProps = {
  message: 'Please contact your administrator if the problem persists.',
  title: 'Sorry, the page you are looking for does not exist.',
}

const NotFoundPageComponent = withStyles(styles)(NotFoundPage)
NotFoundPageComponent.displayName = 'NotFoundPage'
export default NotFoundPageComponent
